import { Controller } from 'react-hook-form'
import CKEditor from 'ckeditor4-react'

export default function EditEditorCell({ rowData, dataKey, register, control, ...props }) {
  const editing = rowData.status === 'EDIT'
  return (
    <div {...props} className={editing ? 'table-content-editing' : 'working-detail-view'}>
      {editing && rowData[dataKey] != undefined ? (
        <Controller
          name={rowData.id}
          control={control}
          defaultValue={rowData[dataKey] || ''}
          render={(props) => {
            return (
              <CKEditor
                data={props.value}
                config={{
                  versionCheck: false,
                  toolbar: [['Bold']],
                  contentsCss: [
                    'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                    'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                  ],
                }}
                onChange={(e) => {
                  props.onChange(e.editor.getData())
                }}
              />
            )
          }}
        />
      ) : (
        <span
          className="working-detail"
          dangerouslySetInnerHTML={{ __html: rowData[dataKey] }}
        ></span>
      )}
    </div>
  )
}
